import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logEvent } from "@/lib/analytics";

export function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Two-pass scroll to defeat any late layout shifts (image loads, etc.)
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    requestAnimationFrame(() => window.scrollTo(0, 0));
    logEvent("page_view", { path: pathname + (search || "") });
  }, [pathname, search]);
  return null;
}
